import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
} from '@mui/material';

/**
 * EditSessionModal:
 * - Muestra un formulario con los datos de la sesión (number, name, date, startTime).
 * - Al hacer clic en "Guardar", llama a onEditSession(sessionActualizado).
 */
function EditSessionModal({ open, onClose, sessionToEdit, onEditSession }) {
  const [formValues, setFormValues] = useState({
    number: '',
    name: '',
    date: '',
    startTime: '',
  });

  // Cuando sessionToEdit cambie o se abra el modal, llenamos formValues
  useEffect(() => {
    if (sessionToEdit) {
      setFormValues({
        number: sessionToEdit.number || '',
        name: sessionToEdit.name || '',
        date: sessionToEdit.date || '',
        startTime: sessionToEdit.startTime || '',
      });
    }
  }, [sessionToEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (!sessionToEdit) return;
    const updatedSession = {
      ...sessionToEdit,
      number: formValues.number,
      name: formValues.name,
      date: formValues.date,
      startTime: formValues.startTime,
    };
    onEditSession(updatedSession);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Editar Sesión</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Número"
              type="number"
              name="number"
              value={formValues.number}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField
              label="Nombre"
              name="name"
              value={formValues.name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Fecha"
              type="date"
              name="date"
              value={formValues.date}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Hora Inicio"
              type="time"
              name="startTime"
              value={formValues.startTime}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSave}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditSessionModal;
